import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import brandService from '../../services/brand';
import { extractPaginatedResponse } from '../../helpers/extractPaginatedResponse';

const initialState = {
  loading: false,
  brands: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
  links: {},
};

export const fetchBrands = createAsyncThunk(
  'brand/fetchBrands',
  (params = {}) => {
    return brandService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchBrands.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchBrands.fulfilled, (state, action) => {
      const { payload } = action;
      const requestParams = action.meta?.arg ?? {};
      const { list, meta } = extractPaginatedResponse(payload);
      const pagination = payload?.pagination ?? {};
      const laravelMeta = payload?.meta ?? {};

      state.loading = false;
      state.brands = list;
      state.meta = {
        total: meta.total,
        per_page: meta.perPage,
        current_page: meta.page,
        last_page:
          meta.lastPage ??
          laravelMeta.last_page ??
          pagination.lastPage,
        from: laravelMeta.from,
        to: laravelMeta.to,
      };
      state.links = payload?.links ?? {};
      state.params.page = state.meta.current_page ?? requestParams.page ?? state.params.page;
      state.params.perPage =
        state.meta.per_page ?? requestParams.perPage ?? state.params.perPage;
      state.error = '';
    });
    builder.addCase(fetchBrands.rejected, (state, action) => {
      state.loading = false;
      state.brands = [];
      state.error = action.error.message;
    });
  },
});

export default brandSlice.reducer;
